import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconListComponent from './IconList.styles';
import { PlaceholderWrapper, Wrapper } from './IconList.styles';
import {isEditorActive, Placeholder, withSitecoreContext} from "@sitecore-jss/sitecore-jss-react";
import Icon from "../shared/Icon/Icon";


const IconList = () => {
    const [content, setContent] = useState('');
    const experienceEditor = isEditorActive();
    const { rendering = {} } = props;
    const listItems = rendering?.placeholders?.['testimonial-carousel-content'] || [];

    const Items = Array.isArray(ListItems)
        ? listItems.map((item, index) => ({ ...item, slideIndex: index }))
        : [];


    if (experienceEditor || sitecoreContext?.pageEditing) {
        return (
            <IconListComponent>
                <div className="testimonial-carousel">
                    <div style={{height: '80px', maxHeight: '80px', borderBottom: '2px solid #944000'}}>
                        <h1>Start Icon List</h1>
                    </div>
                    <PlaceholderWrapper>
                        <Placeholder name="icon-list-content" rendering={rendering}/>
                    </PlaceholderWrapper>
                    <div style={{ height: '80px', maxHeight: '80px', borderTop: '2px solid #944000' }}>
                        <h1>End Icon List</h1>
                    </div>
                </div>
            </IconListComponent>
        );
    }

    return (
        <IconListComponent>
            <Wrapper>
                <div>
                    <h2>Content</h2>
                    <textarea value={content} onChange={handleContentChange} placeholder="Enter content here" />
                </div>
                <ul>
                    {Items.map((benefit, index) => (
                        <li className="benefit-icon" key={`${benefit?.key}-${index}`}>
                            {props.fields?.icon && <Icon icon={props.fields.icon} />}
                            {props.fields?.text && <h3>{props.fields.text}</h3>}
                        </li>
                    ))}
                </ul>
            </Wrapper>
        </IconListComponent>
    );
};

IconList.propTypes = {};

export default withSitecoreContext()(IconList);